import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider, Feature_NAMESPACES } from "@/lib/i18n";

const EsgDashboardPage = lazy(() => import("./pages/EsgDashboardPage"));

export const esgDashboardRoutes = [
  {
    path: PATHS.ANALYTICS_DASHBOARD,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.ESG_DASHBOARD_V3}>
        <EsgDashboardPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "esg_dashboard", action: "view" } },
  },
];
